export default __webpack_public_path__ + "static/media/zodiacToto-Dragon.d67f0cb6.png";